export const environment = {
  'production': true,
  'proxy': 'https://proxy-dev.swaas.de',
  'mcp': 'https://mcp-dev.swaas.de/',
  'MCP_CLIENTS_JSON': 'https://mcp-dev.swaas.de/clients.json',
  'clientID': 109,
  'apiURL': 'https://vtw-dev-api.plusservices.de',
  'appVersion': require('../../package.json').version,
  'ngVersion': require('../../package.json').dependencies['@angular/pwa'],
  'appName' : 'WIO Dashboard'
}
